import { Page } from "table-engine";
import { menusTable } from "./config/tables";

export default function TableEngine() {
    return <Page canCreate={false} table={menusTable} />;
}
